import get from "lodash.get";
import { LoggerService as lgg, WorkspacesService } from "vue-components-library";

import router from "@/App/router";
import { setHotjarIdentity } from "@/App/services";
import { ILoginRequest, AuthorizationService, ILoginResponse, getUsersEmsAgencies } from "@/Login/services";
import { PLEASE_FILL_PASSWORD, PLEASE_FILL_USERNAME } from "@/Login/store/Messages";

const LOG_TAG = "[LOGIN STORE]";

export const actions = {
  async loadGlobalAdminAgencies({ commit }: any) {
    const agencies = await AuthorizationService.loadGlobalAdminAgencies();
    commit("SET_GLOBAL_ADMIN_AGENCIES", agencies);
  },

  async login({ commit, dispatch }: any, data: ILoginRequest) {
    if (!data.username || !data.password) {
      if (!data.username) {
        commit("SET_USERNAME_ERROR", PLEASE_FILL_USERNAME);
      }
      if (!data.password) {
        commit("SET_PASSWORD_ERROR", PLEASE_FILL_PASSWORD);
      }
      return;
    }
    commit("SET_LOADING", true);

    try {
      const loginResponse = await AuthorizationService.login(data);
      dispatch("setupUser", loginResponse);
      router.push("/");
    } catch (error) {
      dispatch("setGeneralError", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  setupUser({ commit, dispatch }: any, loginResponse: ILoginResponse) {
    const { authorizationToken, user } = loginResponse;
    commit("SET_AUTH", authorizationToken);
    commit("SET_USER", user);

    lgg.addUserToDatadogContext(user);
    lgg.info(`${LOG_TAG} User ${user.displayName} logged in`, user);

    const { displayName, email, id: userID, username } = user;

    dispatch("setHotjarIdentity", { displayName, email, userID, username });

    let emsAgencies = getUsersEmsAgencies(user);
    if (emsAgencies.length === 1) {
      commit("SET_AGENCY", emsAgencies[0]);
    }
    if (user.isAdmin) {
      dispatch("loadGlobalAdminAgencies");
    }
  },

  logout({ commit, getters, dispatch }: any) {
    const { workspaceApp } = getters;

    try {
      AuthorizationService.logout();
      commit("RESET_STATE");

      lgg.info(`${LOG_TAG} Logout`);
      lgg.removeUserFromDatadogContext();

      const cognitoSignout = get(workspaceApp, "cognito.signout");
      if (cognitoSignout) {
        window.location.href = cognitoSignout;
        return;
      }

      router.push("/login");
    } catch (error) {
      dispatch("setGeneralError", error);
    }
  },

  setSelectedEMSAgency({ commit }: any, agency: any) {
    commit("SET_AGENCY", agency);
  },

  setGeneralError({ commit }: any, error: any) {
    lgg.error(`${LOG_TAG}`, error);
    commit("SET_GENERAL_ERROR", error);
  },

  setHotjarIdentity(context: any, { displayName, email, userID, username }: any) {
    setHotjarIdentity({ displayName, email, userID, username });
  },

  async setupWorkspaceApp({ commit }) {
    const app = await WorkspacesService.app({
      appName: process.env.VUE_APP_APP_NAME,
      subdomain: WorkspacesService.findSubdomain()
    });

    if (!app) {
      return;
    }

    commit("SET_WORKSPACE_APP", app);
  }
};
